<template>
  <div class="w-95 pl-5" ref="panel">
    <div class="row w-100 justify-content-start">
      <div style="width: calc(100vw - 50px);  height: calc(100vh - 20px);"> <!-- border: 1px solid black; -->
        <matrix :groupData="streamings" :panelWidth='panelWidth'></matrix>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Matrix from "../../components/Matrix.vue";

export default {
  components: { Matrix },
  data() {
    return {
      streamings: [
        { id: 1, title: '石梯坪', url: "https://thbcctv14.thb.gov.tw/T11-062K+100?resolution=CIF_352X288" },
        { id: 2, title: '八仙洞', url: "https://thbcctv11.thb.gov.tw/T11-76K+950?resolution=CIF_352X288" },
        { id: 3, title: '三仙台', url: "https://thbcctv11.thb.gov.tw/T11-110K+100?resolution=CIF_352X288" },
        {},
        {},
        {},
        {},
        {}
      ],
      panelWidth: null,
      resizeInterval: null
    };
  },
  methods: {
    handleResize() {
      this.panelWidth = this.$refs.panel.clientWidth
    },
  },
  mounted(){
    this.resizeInterval = setInterval(async () => {
      this.handleResize();
    }, 1000);
    
  },
  destroyed(){
    if (this.resizeInterval) clearInterval(this.resizeInterval);
    this.resizeInterval = null;
    
  },
};
</script>

